import React from 'react';
import useSWR from 'swr';

import { Card } from '@shopify/polaris';

import { getMetrics } from '../../utils/woorankApi';
import { removeNullValuesFromBeginningAndEnd } from '@hydra/utils/scoreGraphUtils';
import ScoreGraph from '@hydra/common/components/ScoreGraph';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    border: 'none',
    borderRadius: 0,
    marginBottom: 0
  },
  textContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
}));

const X_AXIS_DAYS = 30;

type ScoreHistoryParams = {
  url: string;
  apiKey: string;
};

export default function ScoreHistory ({ url, apiKey }: ScoreHistoryParams) {
  const classes = useStyles();

  const { data: scoreDataSource, error } = useSWR(
    apiKey ? `/woorank-api/metrics/${url}` : null,
    () => getMetrics(url, apiKey)
  );
  const values = ((scoreDataSource || {}).values || [])
    .map((v: any) => {
      return { ...v, value: v.metrics.score };
    });

  let scoreData = removeNullValuesFromBeginningAndEnd(values)
    .map((props: { value: number | null; }) => ({ ...props, value: props.value === null ? null : Math.round(props.value) }));
  if (scoreData.length < X_AXIS_DAYS) {
    const dummyData = Array(X_AXIS_DAYS - scoreData.length).fill({ timestamp: null, value: null });
    scoreData = (scoreData.concat(dummyData));
  }
  return (
    <>
      <Card sectioned>
        <ScoreGraph
          isLoading={scoreDataSource === null}
          data={scoreData}
          className={classes.root}
        />
      </Card>
    </>
  );
}
